import type { DayJsCalendarConfigByLocale } from "./dayjs.type";

export const DAYSJS_DEFAULT_DATE_FORMAT = "YYYY-MM-DD";

export const DAYSJS_CALENDAR_CONFIG: DayJsCalendarConfigByLocale = {
  fr: {
    sameDay: "[Aujourd'hui à] h:mm A",
    nextDay: "[Demain à] h:mm A",
    lastDay: "[Hier à] h:mm A",
    nextWeek: "dddd [à] h:mm A",
    lastWeek: "dddd [dernier] [à] h:mm A",
    sameElse: DAYSJS_DEFAULT_DATE_FORMAT,
  },
  en: {
    // For english, override only the full date format
    sameElse: DAYSJS_DEFAULT_DATE_FORMAT,
  },
};
